import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { KITCHEN_SINK, KITCHEN_SINK_ROWS } from 'actions/kitchenSink';

const INITIAL_STATE = Immutable({
  loading: false,
  initialized: false,
  rowsLoading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${KITCHEN_SINK}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${KITCHEN_SINK}_ERROR`:
      return state.merge({
        initialized: true,
        loading: false,
        error: action.payload,
      });
    case KITCHEN_SINK:
      return state.merge({
        loading: false,
        initialized: true,
        data: action.payload,
        error: null,
      });
    case `${KITCHEN_SINK_ROWS}_LOADING`:
      return state.merge({ rowsLoading: true, error: null });
    case `${KITCHEN_SINK_ROWS}_ERROR`:
      return state.merge({ rowsLoading: false, error: action.payload });
    case KITCHEN_SINK_ROWS: {
      return state.merge(
        {
          data: {
            rows: state.data.rows.map(item => {
              const newRow = action.payload.rows[item.id];
              return newRow ? item.merge({ data: newRow }) : item;
            }),
            hero: action.payload?.hero || state.data.hero,
          },
          rowsLoading: false,
        },
        { deep: true },
      );
    }
    default:
      return state;
  }
};
